module.exports = __webpack_public_path__ + "static/media/toiletTachiagari.2afb7333.png";